import { Input } from '@/lib';
import { Select } from '@/lib/Selects';
import { AudienceSyncTimeBasedSchedule, SyncScheduleUnit } from '@/models/audiences';
import { Fragment, FunctionComponent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AudienceSyncRepeatMonthday } from './AudienceSyncRepeatMonthday';
import { AudienceSyncRepeatWeekday } from './AudienceSyncRepeatWeekday';

interface IAudienceSyncRepeatUnitProps {
  scheduleConfiguration: AudienceSyncTimeBasedSchedule;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
}

type UnitOption = { id: SyncScheduleUnit; label: string };

export const AudienceSyncRepeatUnit: FunctionComponent<IAudienceSyncRepeatUnitProps> = ({ scheduleConfiguration, setFieldValue }) => {
  const { t } = useTranslation('ALL');

  const units: UnitOption[] = [
    {
      id: 'HOURS',
      label: t('hour_other'),
    },
    {
      id: 'DAYS',
      label: t('day_other'),
    },
    {
      id: 'WEEKS',
      label: t('week_other'),
    },
    {
      id: 'MONTHS',
      label: t('month_other'),
    },
  ];
  const [unit, setUnit] = useState<UnitOption>(units.find((item) => item.id === scheduleConfiguration.unit) || units[0]);

  useEffect(() => {
    if (unit) {
      setFieldValue('scheduleConfiguration.unit', unit.id);
    }
  }, [unit]);

  return (
    <Fragment>
      <div className='mb-6 flex flex-row items-center'>
        <span className='mr-4'>{t('thenRepeatsEvery')}</span>
        <div className='mr-4 w-20'>
          <Input
            type='number'
            min={1}
            value={scheduleConfiguration.repeatsEvery}
            onChange={(e) => setFieldValue('scheduleConfiguration.repeatsEvery', parseInt(e.target.value))}
          />
        </div>
        <div className='mr-4'>
          <Select items={units} value={unit} onChange={(value) => setUnit(value as UnitOption)} />
        </div>
        {unit.id === 'WEEKS' && <AudienceSyncRepeatWeekday scheduleConfiguration={scheduleConfiguration} setFieldValue={setFieldValue} />}
      </div>
      {unit.id === 'MONTHS' && <AudienceSyncRepeatMonthday scheduleConfiguration={scheduleConfiguration} setFieldValue={setFieldValue} />}
    </Fragment>
  );
};
